import { useStyles } from './styles'
import { AppButton } from '@/shared/ui/button'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { PlatformVariant } from '@/entities/platforms/types'
type ConnectPlatformProps = {
  onShowDataInfo?: () => void
  onCloseDataInfo?: () => void
  platform: PlatformVariant
  onConnect: () => void
  onReject: () => void
  isLoading: boolean
}

export const ConnectPlatform = (props: ConnectPlatformProps) => {
  const { platform, onConnect, onReject, onShowDataInfo, isLoading } = props
  const { classes } = useStyles()

  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.connectPlatform[platform]

  return (
    <div className={classes.contentRoot}>
      <div className={classes.headerWrapper}>
        <img src={`/assets/social/${platform}.webp`} className={classes.platformImg} />
        <span>{texts.title}</span>
      </div>
      <div className={classes.paragraphs}>
        <span>{texts.paragraph1}</span>
        <span>{texts.paragraph2}</span>
        {'whatDataLink' in texts && (platform === 'steam' || platform === 'egs') && (
          <span className={classes.whatData} onClick={onShowDataInfo}>
            {texts.whatDataLink}
          </span>
        )}
      </div>
      <div className={classes.buttonsContainer}>
        <AppButton fullWidth className={classes.connectButton} isLoading={isLoading} onClick={onConnect}>
          <span>{texts.connect}</span>
        </AppButton>
        <AppButton fullWidth className={classes.noSteamButton} onClick={onReject}>
          {texts.reject}
        </AppButton>
      </div>
    </div>
  )
}
